module.exports = __webpack_public_path__ + "static/media/cert_159.3ecdaa8e.jpg";